import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-message-dialog-box',
  templateUrl: './message-dialog-box.component.html',
  styleUrls: ['./message-dialog-box.component.scss']
})
export class MessageDialogBoxComponent {


  constructor(
    public dialogRef: MatDialogRef<MessageDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public info: any) {

   }

  confirmDialogBox(check:boolean) {
    this.dialogRef.close(check);
  }

}
